import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

export function Paytmredirect() {
    const location = useLocation();
    const query = new URLSearchParams(location.search).toString();

    const [responseData, setResponseData] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const paytmUrl = `https://stg.docubay.com/paytmqrgeneration?${query}`;

        // axios.get(paytmUrl,{headers:{
        //     'Accept': "application/json"
        // }})
        //     .then(response => {
        //         setResponseData(response.data);
        //         setLoading(true);
        //     })
        //     .catch(error => console.error('Error fetching data:', error));
        fetch(paytmUrl)
        .then(response => response.json())
        .then(data => {
            setResponseData(data);
                    setLoading(true);
        });
    }, [query]);


    return (
        <>
            <div>
                {loading && responseData && (
                    <pre>{JSON.stringify(responseData ,null ,2)}</pre>
                )}

            </div>
        </>
    )
}